// extracted by mini-css-extract-plugin
export default {"button_common":"Base_button_common__kkXOg","error":"Base_error__TkgcO","App":"Base_App__KhUW-"};